export default __webpack_public_path__ + "static/media/iconePessoaFisica.b007b304.png";